import clsx from 'clsx'
import { myOrganizationLogoSelector } from 'domains/authentication/selectors/organizations'
import { TRUSTED_APP_RATING_ORG_LOGO_IDENTIFIER } from 'domains/trustedApps/constants/trustedAppsCustomRating'
import { TrustedAppRating } from 'domains/trustedApps/models/ITrustedApplication'
import React from 'react'
import { useSelector } from 'react-redux'

interface TrustedAppsRatingChipProps {
  rating?: TrustedAppRating
  parentOrgLogo?: string
}

export const UNRATED = {
  iconIdentifier: 'fa-minus',
  iconColor: 'gray',
  ratingText: 'Unrated',
}

export function TrustedAppsRatingChip(props: TrustedAppsRatingChipProps) {
  const myLogo = useSelector((s: any) => myOrganizationLogoSelector(s, {}))
  const logo = props.parentOrgLogo || myLogo

  const rating = props.rating || UNRATED

  return (
    <div className="flex items-center gap-2">
      {rating.iconIdentifier === TRUSTED_APP_RATING_ORG_LOGO_IDENTIFIER ? (
        <img width={20} height={20} src={logo} alt="Organization Logo" />
      ) : (
        <i
          className={clsx(`fas text-xl`, rating.iconIdentifier)}
          style={{ color: rating.iconColor }}
        />
      )}

      <span>{rating.ratingText}</span>
    </div>
  )
}
